import { React, Table } from '@1337lawyers/design';

export const AvailableVerificationRequests = () => (
  <Table headers={['Task', 'Requested', 'Status']} data={[]} />
);
